import { render } from "./SmsScheduled.vue?vue&type=template&id=1fff048c&scoped=true"
import script from "./SmsScheduled.vue?vue&type=script&lang=js"
export * from "./SmsScheduled.vue?vue&type=script&lang=js"

import "./SmsScheduled.vue?vue&type=style&index=0&id=1fff048c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fff048c"]])

export default __exports__